// extracted by mini-css-extract-plugin
module.exports = {"root":"_3Ey1U","status":"_2EHce","offer":"_8HZlx","text":"_1qEF-"};